import { Link } from 'react-router-dom'
import SectionTitle from '../ui/SectionTitle'
import ServiceCard  from '../services/ServiceCard'
import Button       from '../ui/Button'
import { useServices } from '../../hooks/useServices'

const FALLBACK = [
  { id: 1, title: 'Themed Decoration', description: 'Custom themes from princesses to superheroes — every detail perfectly curated.',        icon: '🎨', color: '#FF6BB5' },
  { id: 2, title: 'Entertainment',     description: 'Professional entertainers, games, and activities that keep kids engaged all party long.', icon: '🎭', color: '#7C3AFF' },
  { id: 3, title: 'Birthday Cake',     description: 'Stunning custom cakes designed to match your party theme and wow every guest.',           icon: '🎂', color: '#FFC300' },
  { id: 4, title: 'Photography',       description: 'Capture every magical moment with our professional photography packages.',                icon: '📸', color: '#22C55E' },
]

export default function ServicesSection() {
  const { data: services, isLoading } = useServices()
  const items = (services?.length ? services : FALLBACK).slice(0, 4)

  return (
    <section className="section-padding bg-surface">
      <div className="container-custom">
        <SectionTitle
          eyebrow="What We Offer"
          title="Everything Your Party Needs"
          subtitle="From magical decorations to entertainment — we handle every detail so you can enjoy the moment."
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {(isLoading ? Array(4).fill(null) : items).map((service, i) =>
            isLoading ? (
              <div key={i} className="h-64 skeleton" />
            ) : (
              <ServiceCard
                key={service.id}
                service={service}
                index={i}
              />
            )
          )}
        </div>

        <div className="text-center mt-12">
          <Button to="/services" variant="secondary">
            Explore All Services
          </Button>
        </div>
      </div>
    </section>
  )
}
